import { Paper, Typography, Box, Stack, Divider, useTheme, alpha } from '@mui/material';
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';

const AboutPage = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                py: 4,
                px: 2,
            }}
        >
            <Paper
                sx={{
                    padding: { xs: 4, sm: 5 },
                    maxWidth: 600,
                    width: '100%',
                    borderRadius: 3,
                    border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    boxShadow: theme.palette.mode === 'light'
                        ? '0 4px 20px rgba(0, 0, 0, 0.08)'
                        : '0 4px 20px rgba(0, 0, 0, 0.3)',
                }}
            >
                {/* Icon */}
                <Box
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 60,
                        height: 60,
                        borderRadius: '16px',
                        background: alpha(theme.palette.primary.main, 0.1),
                        color: 'primary.main',
                        mb: 3,
                    }}
                >
                    <InfoIcon sx={{ fontSize: 30 }} />
                </Box>

                {/* Title */}
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                        fontWeight: 700,
                        color: 'text.primary',
                        mb: 3,
                    }}
                >
                    About MailFlow Monitor
                </Typography>

                {/* Description */}
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                        lineHeight: 1.7,
                        mb: 4,
                    }}
                >
                    A secure email monitoring platform designed to track and analyze email flows in real-time. 
                    Monitor deliveries, search historical records, and gain insights into your email infrastructure.
                </Typography>

                <Divider sx={{ my: 3 }} />

                {/* Version Info */}
                <Stack spacing={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            Version
                        </Typography>
                        <Typography variant="body1" fontWeight={600} color="text.primary">
                            v2.0
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            Build
                        </Typography>
                        <Typography variant="body1" fontWeight={600} color="text.primary">
                            Phoenix Release
                        </Typography>
                    </Box>
                </Stack>
            </Paper>
        </Box>
    );
};

export default AboutPage;